import * as actionTypes from './actiontypes'
import * as API from './api'
import { log } from '../../config/utils'

export const updateConversionState = payload => {
  return {
    type: actionTypes.UPDATE_CONVERSION_STATE,
    payload
  }
}

export const getFunnelAnalyticsData = (data, callback) => dispatch => {
    dispatch(updateConversionState({
      funnel_data_loading: true,
      funnel_data_load_error: false
    }))
    API.getFunnelAnalyticsData(data, (error, response) => {
      log('getFunnelAnalyticsData', response)
      if (!error && response && response.data && response.data.salesFunnelAnalyticsData && response.data.topConversionDrivers) {
        dispatch({
          type: actionTypes.FUNNEL_DATA_LOADED,
          payload: response.data,
        })
        if (callback) callback()
      } else {
        dispatch(updateConversionState({
          funnel_data_loading: false,
          funnel_data_load_error: true
        }))
      }
    })
  }



// WEBPACK FOOTER //
// ./src/data/redux/conversion_details/actions.js